<template>
	<div class="leaderboard-users">
		<SpinLoader v-if="loading" />

		<template v-if="!loading">
			<!-- User Positions -->
			<!-- <Positions /> -->
			<TopUsers :users="users.top" />

			<!-- User List -->
			<UserList :users="userArray" :top="users.top" />
		</template>
	</div>
</template>

<script>
import { ref, reactive, computed } from 'vue';
import SpinLoader from '@/components/panel/SpinLoader';
import axios from '@axios';
// import Positions from '@/components/panel/Leaderboard/Positions.vue';
import TopUsers from '@/components/panel/Leaderboard/TopUsers.vue';
import UserList from '@/components/panel/Leaderboard/UserList.vue';
export default {
	name: 'LeaderboardUsers',
	components: {
		SpinLoader,
		// Positions,
		TopUsers,
		UserList,
	},
	props: {
		tab: Number
	},
	setup(props) {
		const loading = ref(false);
		const users = reactive({
			top: [],
			all: [],
			daily: [],
			weekly: [],
			monthly: []
		});

		const userArray = computed(() => {
			const newTab = props.tab;
			if (newTab === 1) {
				return actions.filterUsers(users.all)
				// return [...users.all];
			}
			if (newTab === 2) {
				return actions.filterUsers(users.daily)
				// return [...users.daily];
			}
			if (newTab === 3) {
				return actions.filterUsers(users.weekly)
				// return [...users.weekly];
			}
			if (newTab === 4) {
				return actions.filterUsers(users.monthly)
				// return [...users.monthly];
			}

			return []
		})

		const actions = {
			fetchData: function () {
				loading.value = true;
				axios
					.get('/leaderboard')
					.then(res => {
						// console.log(`Leaderboard is:\n${JSON.stringify(res.data, null, 4)}`);

						users.all = res.data.all;
						users.daily = res.data.daily;
						users.monthly = res.data.monthly;
						users.weekly = res.data.weekly;
					})
					.finally(() => {
						loading.value = false;
					});
			},

			filterUsers: function (items) {
				if (Array.isArray(items)) {
					
					// Get Top 3
					const top = items.filter((user, index) => index < 3)
					users.top = [...top]

					// All Other Users
					const otherUsers = items.filter((user, index) => index > 2)
					return otherUsers
				}



				// if (Array.isArray(items) && (items.length > 0 && items.length < 4)) {

				// 	users.top = [...items]

				// 	return []
				// }
				// if (Array.isArray(items) && items.length > 3) {
				// 	items.splice(0, 3)

				// 	return items
				// }

				return []
			}
		};

		// Load initial data.
		actions.fetchData();

		return { actions, loading, users, userArray };
	},
};
</script>
